<h2 mat-dialog-title class="text-xl font-semibold">
  Add from Existing Users
</h2>

<div mat-dialog-content>
  <form [formGroup]="form" class="flex flex-col gap-4" autocomplete="off">
    <div class="flex items-start gap-3">
      <mat-form-field appearance="fill" class="flex-1">
        <mat-label>Email Address</mat-label>
        <input matInput formControlName="emailAddress" placeholder="name@example.com" />
        @if (form.controls['emailAddress']?.errors?.['email']) {
          <mat-error>Please enter a valid email address</mat-error>
        }
        @if (form.controls['emailAddress']?.errors?.['required']) {
          <mat-error>Email address is required</mat-error>
        }
      </mat-form-field>

      <button
        type="button"
        mat-raised-button
        color="primary"
        class="self-start mt-[6px]"
        (click)="onSearch()"
        [disabled]="searching"
      >
        @if (!searching) { <mat-icon>search</mat-icon> }
        @if (!searching) { <span>&nbsp;Search</span> }
        @if (searching) { <span>Searching…</span> }
      </button>
    </div>

    @if (notFound) {
      <div class="text-red-600 text-sm">No user found with that email.</div>
    }

    @if (showDetails) {
      <ng-container>
        <mat-form-field appearance="fill">
          <mat-label>Building</mat-label>
          <mat-select formControlName="buildingId" (selectionChange)="onBuildingChanged($event)">
            @for (building of data.buildings; track building.id) {
              <mat-option [value]="building.id">{{ building.name }}</mat-option>
            }
          </mat-select>
          @if (form.controls['buildingId']?.errors?.['required']) {
            <mat-error>Please select a building</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Role</mat-label>
          <mat-select formControlName="roleId">
            @for (role of roles; track role.id) {
              <mat-option [value]="role.id">{{ role.name }}</mat-option>
            }
          </mat-select>
          @if (form.controls['roleId']?.errors?.['required']) {
            <mat-error>Please select a role</mat-error>
          }
        </mat-form-field>
      </ng-container>
    }
  </form>
</div>

<div mat-dialog-actions class="flex justify-end gap-2">
  <button mat-button type="button" (click)="close()">Cancel</button>
  <button
    mat-raised-button
    color="primary"
    type="button"
    [disabled]="!showDetails || !form.value.buildingId || !form.value.roleId"
    (click)="save()"
  >
    <mat-icon>check</mat-icon>&nbsp;Add
  </button>
</div>